import React, { lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { SuspenseWrapper } from 'components/containers';

const RecordRequestLazy = lazy(() =>
  import(/* webpackChunkName: "record-request" */ 'pages').then(({ RecordRequest }) => ({
    default: RecordRequest,
  })),
);

const PatientLazy = lazy(() =>
  import(/* webpackChunkName: "record-request-patient" */ 'pages/recordRequest/patient/Patient').then(
    ({ Patient }) => ({
      default: Patient,
    }),
  ),
);

const DateLazy = lazy(() =>
  import(/* webpackChunkName: "record-request-date" */ 'pages/recordRequest/date/Date').then(({ DateComp }) => ({
    default: DateComp,
  })),
);

const AuthSelectionLazy = lazy(() =>
  import(/* webpackChunkName: "record-request-authorization" */ 'pages/recordRequest/authorization/AuthSelection').then(
    ({ AuthSelection }) => ({
      default: AuthSelection,
    }),
  ),
);

const AuthorizationLazy = lazy(() =>
  import(/* webpackChunkName: "record-request-authorization" */ 'pages/recordRequest/authorization/Authorization').then(
    ({ Authorization }) => ({
      default: Authorization,
    }),
  ),
);

const GovtIdLazy = lazy(() =>
  import(/* webpackChunkName: "record-request-authorization" */ 'pages/recordRequest/govtId/GovtId').then(
    ({ GovtId }) => ({
      default: GovtId,
    }),
  ),
);

const SupportingDocs = lazy(() => import('pages/recordRequest/supportingDocs/SupportingDocs').then(({ SupportingDocs }) => ({ default: SupportingDocs })));
const RequestInfo = lazy(() => import('pages/recordRequest/requestInfo/RequestInfo').then(({ RequestInfo }) => ({ default: RequestInfo })));

const PaymentLazy = lazy(() =>
  import(/* webpackChunkName: "record-request-payment" */ 'pages/recordRequest/payment/Payment').then(
    ({ Payment }) => ({
      default: Payment,
    }),
  ),
);

const AddPaymentLazy = lazy(() =>
  import(/* webpackChunkName: "record-request-add-payment" */ 'pages/recordRequest/addPayment/AddPayment').then(
    ({ AddPayment }) => ({
      default: AddPayment,
    }),
  ),
);

const ConfirmLazy = lazy(() =>
  import(/* webpackChunkName: "record-request-confirm" */ 'pages/recordRequest/confirm/Confirm').then(
    ({ Confirm }) => ({
      default: Confirm,
    }),
  ),
);

const CreatePatientLazy = lazy(() =>
  import(/* webpackChunkName: "record-request-create-patient" */ 'pages/recordRequest/patient/Patient').then(
    ({ CreatePatient }) => ({
      default: CreatePatient,
    }),
  ),
);

const RequestConfirmedLazy = lazy(() =>
  import(
    /* webpackChunkName: "record-request-confirmed" */ 'pages/recordRequest/requestConfirmed/RequestConfirmed'
  ).then(({ RequestConfirmed }) => ({
    default: RequestConfirmed,
  })),
);

const root = '/record-request';

type RecordRequestRouterProps = {
  curruntStep: string | number;
  total: string | number
};

const RootRedirect = () => <Redirect to={`${root}/provider`} />;

export const RecordRequestRouter: React.FC<RecordRequestRouterProps> = ({ curruntStep, total }) => (
  <Switch>
    <SuspenseWrapper>
      <Route path={`${root}/provider`}>
        <RecordRequestLazy />
      </Route>
      <Route path={`${root}/patient`} render={() => (curruntStep > 1 && curruntStep != total ? <PatientLazy /> : <RootRedirect />)} />
      <Route path={`${root}/create-patient`} render={() => (curruntStep > 1 && curruntStep != total ? <CreatePatientLazy /> : <RootRedirect />)} />
      <Route path={`${root}/date`} render={() => (curruntStep > 2 && curruntStep != total ? <DateLazy /> : <RootRedirect />)} />
      <Route path={`${root}/auth-type`} render={() => (curruntStep > 3 && curruntStep != total ? <AuthSelectionLazy /> : <RootRedirect />)} />
      <Route path={`${root}/authorization`} render={() => (curruntStep > 4 && curruntStep != total ? <AuthorizationLazy /> : <RootRedirect />)} />
      <Route path={`${root}/govt-id`} render={() => (curruntStep > 5 && curruntStep != total ? <GovtIdLazy /> : <RootRedirect />)} />
      <Route path={`${root}/supporting-docs`} render={() => (curruntStep > 6 && curruntStep != total ? <SupportingDocs /> : <RootRedirect />)} />
      <Route path={`${root}/request-info`} render={() => (curruntStep > 5 && curruntStep != total ? <RequestInfo /> : <RootRedirect />)} />
      <Route path={`${root}/payment`} render={() => (curruntStep > 6 && curruntStep != total ? <PaymentLazy /> : <RootRedirect />)} />
      <Route path={`${root}/add-payment`} render={() => (curruntStep > 6 && curruntStep != total ? <AddPaymentLazy /> : <RootRedirect />)} />
      <Route path={`${root}/confirm`} render={() => (curruntStep > 7 && curruntStep != total ? <ConfirmLazy /> : <RootRedirect />)} />
      <Route path={`${root}/requestConfirmed`} render={() => (curruntStep == total ? <RequestConfirmedLazy /> : <RootRedirect />)} />

      {/* <Redirect to={`${root}/provider`} /> */}
    </SuspenseWrapper>
  </Switch>
  );